module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <div class=\"title2015\"> </div>\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/general_network/inbound_orig.html
 ** module id = 611
 ** module chunks = 0
 **/